define('lq/events/actions/scrollTo',[
    'lq/events/actions/eventAction',
    'jquery'
], function (EventAction, $) {
    'use strict';

    function ScrollTo(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ScrollTo, EventAction);

    ScrollTo.typeName = 'ScrollTo';

    ScrollTo.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ScrollTo.prototype.execute = function (continuation) {
        var self = this;

        var drop = self.piping.dropFactory.findDropByName(self.eventData.scrollTo);
        if (!drop)
            throw 'Cannot find drop : "' + self.eventData.timer + '" for scroll to event action.';
        if (drop.isVisible()) {
            this.piping.$actionWrapper.animate({
                // offset().top gives back the position relative to the top of the page,
                // it is different if the scroll bar is in different position
                scrollTop: drop.$element.offset().top + this.piping.$actionWrapper.scrollTop()
            }, {
                queue: false
            });
        }

        continuation();
    };

    return ScrollTo;
});
